/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable no-script-url */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import PrintHelper from 'print-helper-lib';
import TransactionGridComponent from './TransactionGridComponent';
import TransactionGridComponentMobile from './TransactionGridComponentMobile';
import Filter from './Filter';
import SegmentedControl from './SegmentedControl';
import TransactionDetailsStaticUtils from '../../../utils/TransactionDetailsStaticUtils';
import TransactionsActionCreator from '../../../actions/TransactionsActionCreator';
import TransactionsStoreNew from '../../../stores/TransactionsStoreNew';
import UserManagementStore from '../../../stores/UserManagementStore';
import SessionStore from '../../../stores/SessionStore';
import RegexUtils from '../../../utils/RegexUtils';
import ApiUtils from '../../../utils/ApiUtils';
import envConfig from '../../../../static/config';
import BrowserUtils from '../../../utils/BrowserUtils';
import StringConstants from '../../../constants/StringConstants';
import TabularTransactionCategoryView from './TabularTransactionCategoryView';
import AccountDetailsBL, { transactionCategories } from './AccountDetailsBL';
import { getBrandId, isBOrVMRetail } from '../../../utils/BrandUtils';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { KapitiTransactions } from 'payments-lib';
import TransactionsDetailsPerAccountComponent from './TransactionsDetailsPerAccount';

let isSearching = false;
const getSessionData = () => ({
  clientContext: ApiUtils.getApiClientContext(),
  accessToken: SessionStore.getAll().accessToken,
  bankId: ApiUtils.getBankId(),
});
class TransactionsDetailsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.moveCaretAtEnd = this.moveCaretAtEnd.bind(this);
    this.onInputSearchChange = this.onInputSearchChange.bind(this);
    this.searchSuggestedPopup = this.searchSuggestedPopup.bind(this);
    this.getSelectedTypeTransaction =
      this.getSelectedTypeTransaction.bind(this);
    this.cancelTransactionSearch = this.cancelTransactionSearch.bind(this);
    this.getSelectedDate = this.getSelectedDate.bind(this);
    this.onResize = this.onResize.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.clearclick = this.clearclick.bind(this);
    this.onTableTagClick = this.onTableTagClick.bind(this);
    this.doTransactionSearch = this.doTransactionSearch.bind(this);
    this.downKeyPress = this.downKeyPress.bind(this);
    this.listKeyPress = this.listKeyPress.bind(this);
    this.searchFocusBlur = this.searchFocusBlur.bind(this);
    this.onTabSelection = this.onTabSelection.bind(this);
    this.renderTransactions = this.renderTransactions.bind(this);
    const sanitizedEnvConfig = {
      ...envConfig,
      brandId: getBrandId(),
    };
    this.state = {
      selectedTab: 'default',
      isPopUpOpen: false,
      maxDate: moment(),
      minDate: moment().subtract(60, 'months'),
      inputFormat: 'DD MMM YY',
      format: 'YYYY-MM-DD',
      when: moment().format('YYYY-MM-DD'),
      open: false,
      enableCrossIcon: false,
      sanitizedEnvConfig,
      viewType: BrowserUtils.getView(),
    };
  }
  componentWillMount() {
    TransactionsActionCreator.getTags();
    window.addEventListener('resize', this.onResize);
  }
  componentWillReceiveProps(nextprops) {
    if (this.props.account !== nextprops.account) {
      this.refs.searchInput.value = '';
      isSearching = false;
    }
  }
  onInputSearchChange() {
    const text = this.refs.searchInput.value;
    this.setState({ enableCrossIcon: text.length > 0 });
    if (text.length > 2) {
      this.doTransactionSearch(text);
      this.setState({ isPopUpOpen: true });
    }
  }
  doTransactionSearch(searchText) {
    TransactionsActionCreator.getSearchTransactionSuggest(searchText);
  }
  moveCaretAtEnd(event) {
    event.preventDefault();
    isSearching = true;
    this.forceUpdate();
  }
  clearclick() {
    this.setState({ enableClearIcon: false }, () => {
      this.refs.searchInput.value = '';
      this.refs.searchInput.focus();
    });
  }
  cancelTransactionSearch() {
    isSearching = false;
    this.refs.searchInput.value = '';
    this.setState({ enableClearIcon: false });
    TransactionsActionCreator.resetSearch();
  }
  searchSuggestedPopup() {
    if (!this.props.suggestData.length) {
      return false;
    } else {
      let suggestion = this.props.suggestData.map((data, index) => (
        <li
          id={`${index}`}
          ref={`listItem${index}`}
          key={index}
          onKeyDown={this.listKeyPress}
          onClick={this.getSelectedTypeTransaction.bind(this, data)}
        >
          <a>{data.text}</a>
        </li>
      ));
      return (
        <ul id="list" ref="list" className="searchSuggest">
          {suggestion}
        </ul>
      );
    }
  }
  getSelectedTypeTransaction(data) {
    if (!_.isUndefined(data)) {
      this.refs.searchInput.value = data.text;
    }
    this.props.getSelectedTypeTransactions(this.refs.searchInput.value);
  }
  getSelectedDate(dateFromFilter) {
    let startDate = moment().startOf('days');
    startDate = startDate.subtract(dateFromFilter, 'months').toISOString();
    this.props.onDateChange(startDate);
  }
  componentWillUnmount() {
    isSearching = false;
    window.removeEventListener('resize', this.onResize);
  }
  onResize() {
    const currentBrowserView = BrowserUtils.getView();

    if (this.state.viewType !== currentBrowserView) {
      this.setState({ viewType: currentBrowserView });
    }
  }
  handleKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (this.refs.searchInput.value.length > 2) {
        if (
          RegexUtils.isValid(
            this.refs.searchInput.value,
            RegexUtils.regexes.timelineSearchData
          )
        ) {
          this.props.getSelectedTypeTransactions(this.refs.searchInput.value);
        }
      }
    }
  }
  outsideClick(e) {
    TransactionsActionCreator.resetPopUp();
  }
  onTableTagClick() {
    BrowserUtils.isTabletView()
      ? this.props.mobileSelectionTag()
      : this.props.onTableTagIconClick();
  }
  onTableTagKeyDown = (event) => {
    switch (event.key) {
      case ' ':
      case 'Enter':
        this.onTableTagClick();
        break;
      default:
        break;
    }
  };
  getLoader() {
    const { showMoreLoaderFlag } = this.props;
    return showMoreLoaderFlag ? (
      <div className="transaction-loader">Loading</div>
    ) : (
      <div />
    );
  }
  downKeyPress(e) {
    if (this.refs.searchInput.value.length > 2) {
      if (this.props.suggestData.length > 0) {
        if (this.props.isPopUpOpen) {
          const list = document.getElementById('list'); // targets the <ul>
          const first = list.firstChild; // targets the first <li>
          const maininput = document.getElementById('timelineSearch'); // targets the input, which triggers the functions populating the list // listen to keyboard events
          switch (e.keyCode) {
            case 38: // if the UP key is pressed
              if (document.activeElement === (maininput || first)) {
                break;
              } // stop the script if the focus is on the input or first element
              else {
                document.activeElement.parentNode.previousSibling.focus();
              } // select the element before the current, and focus it
              break;
            case 40: // if the DOWN key is pressed
              if (document.activeElement === maininput) {
                first.focus();
              } // if the currently focused element is the main input --> focus the first <li>
              else {
                document.activeElement.nextSibling.focus();
              } // target the currently focused element -> <a>, go up a node -> <li>, select the next node, go down a node and focus it
              break;
            case 13:
              this.getSelectedTypeTransaction(
                this.props.suggestData[document.activeElement.id]
              );
              break;
            default:
          }
        }
      }
    }
  }
  listKeyPress(e) {
    if (this.props.suggestData.length > 1) {
      const list = document.getElementById('list'); // targets the <ul>
      const first = list.firstChild; // targets the first <li>
      const last = list.lastChild;
      const maininput = document.getElementById('timelineSearch'); // targets the input, which triggers the functions populating the list // listen to keyboard events
      switch (e.keyCode) {
        case 38: // if the UP key is pressed
          if (
            document.activeElement === maininput ||
            document.activeElement === first
          ) {
            break;
          } // stop the script if the focus is on the input or first element
          else {
            document.activeElement.previousSibling.focus();
          } // select the element before the current, and focus it
          break;
        case 40: // if the DOWN key is pressed
          if (
            document.activeElement === maininput ||
            document.activeElement === last
          ) {
            first.focus();
          } // if the currently focused element is the main input --> focus the first <li>
          else {
            document.activeElement.nextSibling.focus();
          } // target the currently focused element -> <a>, go up a node -> <li>, select the next node, go down a node and focus it
          break;
        case 13:
          this.getSelectedTypeTransaction(
            this.props.suggestData[document.activeElement.id]
          );
          break;
        default:
      }
    }
    if (this.props.suggestData.length === 1 && e.keyCode === 13) {
      this.getSelectedTypeTransaction(
        this.props.suggestData[document.activeElement.id]
      );
    }
  }
  searchFocusBlur() {
    if (!this.props.isPopUpOpen) {
      isSearching = false;
      TransactionsActionCreator.resetPopUp();
    }
  }
  onTabSelection(tabId) {
    this.setState({
      selectedTab: tabId,
    });
  }

  renderTransactions({ taggingIcon }) {
    const dateFilter = TransactionDetailsStaticUtils.getDateFilterFields();
    const typeFilter = TransactionDetailsStaticUtils.getTypeFilterFields();

    const { transactions, isAccountPool, exportTransactions, account } =
      this.props;
    const { sanitizedEnvConfig, selectedTab } = this.state;
    const isPerAccountView = selectedTab === transactionCategories.PERACCOUNT;

    const { brandId } = sanitizedEnvConfig;

    const user = UserManagementStore.getCADetails();

    return (
      <div className="transaction-details pos-r">
        <div className="row transaction-details__headertag">
          <div className="col-xs1-20 col-md1-9">
            <h2 className="transaction-details__header type--arran u-bold pull-left">
              Transactions
            </h2>
          </div>
          <div className="col-xs1-4 mobile-tag">{taggingIcon}</div>
          {!isPerAccountView && (
            <div className="col-xs1-24 col-md1-13">
              <div className=" transaction-details__search">
                <form action="." className="autofillSearch">
                  <input
                    aria-label="Transaction Search"
                    id="timelineSearch"
                    type="search"
                    placeholder=" Search"
                    ref="searchInput"
                    onKeyPress={this.handleKeyPress}
                    onFocus={this.moveCaretAtEnd}
                    onChange={this.onInputSearchChange}
                    className={isSearching ? 'focused' : ''}
                    pattern={RegexUtils.regexes.timelineSearchData}
                    autoComplete="off"
                    minLength={2}
                    onKeyDown={this.downKeyPress}
                  />
                  {this.state.enableCrossIcon &&
                    this.refs.searchInput.value.length > 0 &&
                    isSearching && (
                      <div>
                        <a
                          href="javascript:void(0)"
                          onClick={this.clearclick}
                          aria-label="Clear Search"
                          className="searchClear icon icon-clear"
                        />
                      </div>
                    )}
                  <a
                    href="javascript:void(0)"
                    className="search-cancel opt-green"
                    aria-label="Cancel Search"
                    onClick={this.cancelTransactionSearch}
                  >
                    Cancel
                  </a>
                </form>
                {this.props.isPopUpOpen && (
                  <button
                    className="timeline_backdrop"
                    onClick={this.outsideClick}
                  />
                )}
                {this.props.isPopUpOpen && this.searchSuggestedPopup()}
              </div>
            </div>
          )}
          <div className="col-xs1-4 col-md1-2 tag-desktop">{taggingIcon}</div>
        </div>
        <div
          className="margin-bottom"
          ref={this.props.kapitiTransactionsTableRef}
        >
          <KapitiTransactions
            session={getSessionData()}
            envConfig={sanitizedEnvConfig}
            user={user}
            selectedAccountId={account}
          />
        </div>
        <div className="row transaction-details__filtersegment">
          <div className="col-sm2-15 col-md1-24 col-lg2-15 transaction-details__filter transaction-details__filter@tablet">
            <div className="row">
              <div className="col-sm2-24 col-md1-24 col-lg2-24">
                <Filter
                  content={this.props.content}
                  date={dateFilter}
                  uptoDate
                  onDateChange={this.props.onDateChange}
                  startDate={this.props.startDate}
                  endDate={this.props.endDate}
                  accountChangeFlag={this.props.accountChangeFlag}
                  monthName={this.props.monthName}
                  settingMonthName={this.props.settingMonthName}
                  accountIdFromStore={this.props.accountIdFromStore}
                  settingToDate={this.props.settingToDate}
                  settingFromDate={this.props.settingFromDate}
                  changeOfDate={this.props.changeOfDate}
                  fromChangeOfDate={this.props.fromChangeOfDate}
                />
              </div>
              {isAccountPool && !isPerAccountView && (
                <div className="col-sm2-4 col-md1-12 col-lg2-4 web-ui-components">
                  <Button display="primary" onClick={exportTransactions}>
                    Export Transactions
                  </Button>
                </div>
              )}
            </div>
          </div>
          <div className="col-xs1-24 col-sm2-12 col-md1-16 col-lg2-9">
            <SegmentedControl
              tabs={typeFilter}
              onTabSelect={this.props.tabSelect}
              selectedKey={TransactionsStoreNew.getTypeFilter()}
              segmentedControlDiv="type--jura segmented-control"
            />
          </div>
        </div>
        <PrintHelper
          className="web-ui-components"
          brandId={brandId}
          showPrintTopIcon={!isAccountPool}
          showPrintBottomIcon={transactions.length >= 20}
        >
          {this.renderTransactionTable()}
        </PrintHelper>
        {this.getLoader()}
      </div>
    );
  }

  renderTransactionTable() {
    const { isAccountPool } = this.props;
    const { selectedTab } = this.state;

    if (selectedTab === transactionCategories.PERACCOUNT && isAccountPool) {
      return <TransactionsDetailsPerAccountComponent {...this.props} />;
    }

    const TransactionGrid = !BrowserUtils.isTabletView()
      ? TransactionGridComponent
      : TransactionGridComponentMobile;

    return (
      <TransactionGrid
        {...this.props}
        transactionReadFlag={this.props.transactionReadFlag}
        selectedRowIds={this.props.selectedRowIds}
        isLoading={this.props.isLoading}
        data={this.props.transactions}
        loadNextTransactions={this.props.loadNextTransactions}
        onSort={this.props.onSort}
        loadTransactionsFlag={this.props.loadTransactionsFlag}
        onRowClick={this.props.onRowClick}
        isMultipleSelection={this.props.isMultipleSelection}
        onRowSelect={this.props.onRowSelect}
        onRowSelectAll={this.props.onRowSelectAll}
        rowCustomClass={this.props.rowCustomClass}
        rowClickIndex={this.props.rowClickIndex}
        onTableTagClick={this.props.onTableTagClick}
        onMoreDetailsClick={this.props.onMoreDetailsClick}
        openTransactionInProgressPopUp={
          this.props.openTransactionInProgressPopUp
        }
        transactionServiceErrorFlag={this.props.transactionServiceErrorFlag}
        transactionServiceErrorMessage={
          this.props.transactionServiceErrorMessage
        }
        statusErrorResponse={this.props.statusErrorResponse}
        onRetryClick={this.props.onRetryClick}
      />
    );
  }

  render() {
    const { accDetails, accountType, isAccountPool } = this.props;
    const { selectedTab } = this.state;
    let taggingIcon;

    if (isBOrVMRetail()) {
      if (
        accountType === 'credit_card' ||
        (accDetails &&
          !accDetails.actionsAvailable['/account/transactions/write'])
      ) {
        taggingIcon = <div className="disabled-tag icon icon-tag pull-right" />;
      } else {
        taggingIcon = (
          <div
            className="transaction-details__tag icon icon-tag pull-right"
            role="button"
            tabIndex="0"
            onClick={this.onTableTagClick}
            onKeyDown={this.onTableTagKeyDown}
          />
        );
      }
    }
    if (
      accDetails &&
      accDetails.product.code === StringConstants.KAPITI_PRODUCT_CODE
    ) {
      taggingIcon = <div className="disabled-tag icon icon-tag pull-right" />;
    }
    return (
      <div>
        <TabularTransactionCategoryView
          tabs={AccountDetailsBL.getTransactionCategoryTabList(isAccountPool)}
          currentTab={selectedTab}
          onClick={this.onTabSelection}
        />
        {this.renderTransactions({
          taggingIcon,
        })}
      </div>
    );
  }
}
TransactionsDetailsComponent.propTypes = {
  accDetails: PropTypes.any,
  account: PropTypes.string,
  accountChangeFlag: PropTypes.any,
  accountIdFromStore: PropTypes.any,
  accountType: PropTypes.any,
  changeOfDate: PropTypes.any,
  content: PropTypes.object,
  endDate: PropTypes.any,
  fromChangeOfDate: PropTypes.any,
  getSelectedTypeTransactions: PropTypes.func,
  isAccountPool: PropTypes.bool,
  isLoading: PropTypes.bool,
  isMultipleSelection: PropTypes.bool,
  isPopUpOpen: PropTypes.bool,
  loadNextTransactions: PropTypes.func,
  loadTransactionsFlag: PropTypes.bool,
  mobileSelectionTag: PropTypes.func,
  monthName: PropTypes.any,
  onDateChange: PropTypes.func,
  onRetryClick: PropTypes.any,
  onRowClick: PropTypes.func,
  onRowSelect: PropTypes.func,
  onRowSelectAll: PropTypes.any,
  onSort: PropTypes.func,
  onTableTagClick: PropTypes.func,
  onTableTagIconClick: PropTypes.any,
  onMoreDetailsClick: PropTypes.func,
  openTransactionInProgressPopUp: PropTypes.any,
  rowClickIndex: PropTypes.any,
  rowCustomClass: PropTypes.any,
  selectedRowIds: PropTypes.array,
  settingFromDate: PropTypes.any,
  settingMonthName: PropTypes.any,
  settingToDate: PropTypes.any,
  showMoreLoader: PropTypes.bool,
  showMoreLoaderFlag: PropTypes.any,
  showSelectionTag: PropTypes.bool,
  startDate: PropTypes.any,
  suggestData: PropTypes.array,
  tabSelect: PropTypes.func,
  transactionReadFlag: PropTypes.bool,
  transactionServiceErrorFlag: PropTypes.any,
  transactionServiceErrorMessage: PropTypes.any,
  statusErrorResponse: PropTypes.any,
  transactions: PropTypes.array,
  transactionsLoading: PropTypes.bool,
  kapitiTransactionsTableRef: PropTypes.func,
};

TransactionsDetailsComponent.defaultProps = {
  onSort: () => {},
  transactionsLoading: false,
};

export default TransactionsDetailsComponent;
